import { ContentRenderer } from "@/lib/content/ContentRenderer";
import { ImageRenderer } from "@/lib/content/ImageRenderer";
import { Text } from "@mantine/core";
import CheckRounded from "@mui/icons-material/CheckRounded";
import { QuestionImageOption, QuestionOption } from "@tsTypes/question-schema";
import clsx from "clsx";
import classes from "./MultipleChoiceQuestionOptions.module.css";

export default function MultipleChoiceQuestionOptions({
  options,
  handleAnswerInteraction,
  selectedAnswer,
  marked,
  images,
}: {
  options: QuestionOption[] | QuestionImageOption[];
  handleAnswerInteraction: (answer: string) => void;
  selectedAnswer: string;
  marked: number | undefined;
  images?: true;
}) {
  if (!options) {
    return (
      <Text c="incorrect">
        The image options have not been added. Please report this using the
        button on the bottom right of this question!
      </Text>
    );
  }

  const letters = ["A", "B", "C", "D"];

  return (
    <div style={{ marginTop: "3rem" }}>
      {options.map((option, indx) => {
        const { alt, url, height, width } =
          (option as QuestionImageOption) ?? {};
        const letter = letters[indx];
        const isSelected = selectedAnswer === letter;

        return (
          <div
            key={option.id}
            className={classes.optionContainer}
            onClick={() => {
              if (marked !== undefined && selectedAnswer !== letter) return;
              handleAnswerInteraction(letter);
            }}
            style={{
              opacity: marked !== undefined ? 0.5 : 1,
              cursor: marked !== undefined ? "default" : "pointer",
              marginBottom: indx < options.length - 1 ? "1rem" : 0,
              alignItems: "center",
            }}
          >
            <div
              className={clsx(
                classes.radioButton,
                isSelected && classes.radioButtonSelected
              )}
            >
              {isSelected && <CheckRounded style={{ fontSize: 14 }} />}
            </div>
            <div className={classes.optionContent}>
              {images ? (
                <>
                  <Text fw={600} size="sm">
                    {letter}&nbsp;
                  </Text>
                  <ImageRenderer
                    src={url}
                    alt={alt}
                    width={width}
                    height={height}
                  />
                </>
              ) : (
                <Text component="div" size="sm">
                  <b>{letter}</b>:&nbsp;{" "}
                  <ContentRenderer
                    content={(option as QuestionOption).Option}
                  />
                </Text>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
